import { render, staticRenderFns } from "./RmpSignApplicationStep.vue?vue&type=template&id=087a5584"
import script from "./RmpSignApplicationStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpSignApplicationStep.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports